import { chain, filter } from "lodash"

const QUERY = `query ($modelId: String!, $positionSet: PositionSetInput!, $base: [PositionSetInput], $date: Date!) {
  model (id: $modelId) {
    simulation (positionSet: $positionSet, base: $base, from: $date, to: $date) {
      exposure {
        factors {
          id
          name
          category
          net
        }
      }
    }
  }
}`

export function createExposureSingleDateQuery(modelId, positionSet, base, date, options = {}) {
  return {
    key: ["exposure", "singleDate", modelId, positionSet, base, date],
    query: QUERY,
    variables: {
      modelId,
      positionSet,
      base,
      date,
    },
    select: (data) => {
      const values = chain(data)
        .get("data.model.simulation.exposure.0.factors")
        .thru(factors => {
          if (options.category) {
            return filter(factors, f => f.category === options.category)
          }
          return factors
        })
        .keyBy("id")
        .mapValues(({ name, net }) => ({
          label: name,
          value: net,
        }))
        .value()

      return {
        values,
      }
    },
  }
}
